<div class="align-items-center d-flex justify-content-center vh-100">
    <div>
        <div class="d-flex justify-content-around p-4">
            <img src="assets/images/404.svg" alt="404-error" />
        </div>
        <div class="d-flex justify-content-around">
            <h1 class="fnt-32 text-black334 fw-b fnt-general">
                {{ 'error' | translate }}
            </h1>
        </div>
        <p class="looks-text fnt-22 text-clr588 fw-m p-2 text-center">
            {{ 'looks_like_something' | translate }}
        </p>
        <div class="d-flex justify-content-around mt-3">
            <a class="btn-raised" href="{{ portalUrl }}">{{ 'go_to_homepage' | translate }}</a>
        </div>
    </div>
</div>
